import { CompressedCarouselContext } from './components/variants/Compressed/Compressed'
import { DefaultCarouselContext } from './components/variants/Default/Default'
import Carousel, { TProps } from './Carousel'

export { DefaultCarouselContext, CompressedCarouselContext }

export type { TProps }
export default Carousel
